// extracted by mini-css-extract-plugin
export default {"container":"BTw2d5h91HgWFXn6abAX","item":"qcETznBLLmpqB_A68M8O","label":"T2T28KAriEfZEkvWTidi"};